document.addEventListener('DOMContentLoaded', function() {  
    // custom drop functionalities 
    (function() {
        // product shelf-stable and regrigerated options
        function productStateOption() {
            const productOptionsSelector = '[js-optional-product]'

            const productOptions = document.querySelectorAll(productOptionsSelector)
        
            productOptions.forEach(option => {
                option.addEventListener('click', handleProductChange)
            })
        
            function handleProductChange(e) {
                const option = e.target.closest(productOptionsSelector)
                if(option) {
                    const handle = option.dataset.productHandle
                    fetchAndReplaceSection(handle)
        
                }
            }
        
            function fetchAndReplaceSection(handle) {
                const url = `${handle}?view=lp-featured-product-ajax`

                fetch(url)
                .then((res) => res.text())
                .then((text_) => {
                    const html_ = new DOMParser().parseFromString(text_, 'text/html')
                    const productInfo = html_.querySelector('#product_scroll')
                    document.querySelector('#product_scroll').replaceWith(productInfo)
                    
                    document.dispatchEvent(new CustomEvent("productStateOption:init"));
                    document.dispatchEvent(new CustomEvent("mainProduct:variant:custom"));
                    document.dispatchEvent(new CustomEvent("customProductsList:drop"));
                    document.dispatchEvent(new CustomEvent("activeSelectedProduct")); 
                    document.dispatchEvent(new CustomEvent("init:autoCloseDrop"));
                    document.dispatchEvent(new CustomEvent("accordionProductSection:init"));
                    document.dispatchEvent(new CustomEvent("productStateOption:init"));
                    yotpoWidgetsContainer.initWidgets()
                })
            }
        }
        

        function getSectionsToRender() {
            return [
                {
                    selector: "#product_scroll"
                }
            ]
        }

        function renderSections(handle) {
            getSectionsToRender().forEach(section=>{
                fetch(`/products/${handle}?view=lp-featured-product-ajax`).then(response=>response.text()).then(html => {
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    
                    const elementToReplace = document.querySelector(`${section.selector}`);
        
                    if(elementToReplace) {
                        if(doc.querySelector(`${section.selector}`)) {
                            elementToReplace.replaceWith(doc.querySelector(`${section.selector}`))
                        }
                    };
        
        
                    if(section.selector === "#product_scroll") {
                        document.dispatchEvent(new CustomEvent("mainProduct:variant:custom"));
                        document.dispatchEvent(new CustomEvent("customProductsList:drop"));
                        document.dispatchEvent(new CustomEvent("activeSelectedProduct")); 
                        document.dispatchEvent(new CustomEvent("init:autoCloseDrop"));
                        document.dispatchEvent(new CustomEvent("accordionProductSection:init"));
                        document.dispatchEvent(new CustomEvent("productStateOption:init"));
                        // subscription
                        yotpoWidgetsContainer.initWidgets()
                    };

                    document.body.classList.remove("disabled");

                }
                ).catch(function(error) {
                    console.log(error)
                })
            }
            )
        }

        function updateSelectedProductsDrop(currentTarget) {
            currentTarget.closest('[js-select]').querySelector('[js-dropdown-icon]').classList.remove('icon-rotate')
            currentTarget.closest('[js-select]').querySelector('[js-dropdown-menu]').classList.remove('open-menu')

            document.dispatchEvent(new CustomEvent('activeSelectedProduct'))


        }
        
        class productListOption extends HTMLElement {
            constructor() {
                super(),
                this.selectors = {
                    dropItem: "[js-drop-item]",
                    swatchHandle: "[js-swatch-handle]"
                },
                this.classes = {
                    activeClass: "active"
                },
                this.dropItems = this.querySelectorAll(this.selectors.dropItem),
                this.swatchHandle = this.querySelector(this.selectors.swatchHandle),
                this.init()
            }
            init() {
                productStateOption(),
                this.querySelectorAll("[js-swatch-item][data-solid-item]:not(.hidden)").length == 0 ? document.querySelector("[data-solid-label]") != null && document.querySelector("[data-solid-label]").classList.add("hidden") : document.querySelector("[data-solid-label]") != null && document.querySelector("[data-solid-label]").classList.remove("hidden"),
                this.querySelectorAll("[js-swatch-item][data-print-item]:not(.hidden)").length == 0 ? document.querySelector("[data-print-label]") != null && document.querySelector("[data-print-label]").classList.add("hidden") : document.querySelector("[data-print-label]") != null && document.querySelector("[data-print-label]").classList.remove("hidden"),
                this.dropItems.forEach(swatchItem=>{
                    swatchItem.addEventListener("click", ({currentTarget})=>{
                        this.toggleProduct(currentTarget)
                    }
                    )
                }
                )
            }
            toggleProduct(targetProduct) {
                const productHandle = targetProduct.dataset.productHandle
                , swatchHandle = targetProduct.dataset.swatchHandle;
                
                this.updateState(targetProduct),
                // this.updateHistoryState(productHandle),
                renderSections(productHandle),
                updateSelectedProductsDrop(targetProduct)
            }
            updateState(targetEl) {
                document.body.classList.add("disabled")
                // this.dropItems.forEach(item=>item.classList.remove(this.classes.activeClass)),
                // targetEl.classList.add(this.classes.activeClass)
            }
            updateHistoryState(handle) {
                var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
                window.history.pushState({
                    path: newurl
                }, "", newurl)
            }
        }
        productStateOption()
        document.addEventListener('productStateOption:init', productStateOption)
        customElements.define("product-list-option", productListOption)
    }
    )();
    function customProductListDrop() {
        const dropdown = document.querySelectorAll('[js-dropdown]');
        dropdown.forEach(drop => {
            const dropdownSelect = drop.querySelector('[js-select]');
            const selectedOption = drop.querySelector('[js-selected-option]');
            const dropdownIcon = drop.querySelector('[js-dropdown-icon]');
            const dropdownMenu = drop.querySelector('[js-dropdown-menu]');
            const dropdownList = drop.querySelectorAll('[js-dropdown-item]');
            const dropdownSelectedList = drop.querySelector('[js-dropdown-icon]');
            
            const selectedOptionTitle = document.querySelector('[js-selected-name]')
            const selectedOptionColor = document.querySelector('[js-selected-color]')
            console.log({dropdownSelect})
            if(dropdownSelect) {
                dropdownSelect.addEventListener("click", () => {
                    console.log({dropdownSelect})
                  dropdownIcon.classList.toggle("icon-rotate");
                  dropdownMenu.classList.toggle("open-menu");
                })
            }
    
        })
    }



    customProductListDrop()
    document.addEventListener('customProductsList:drop', customProductListDrop)

    function getSelected() {
        const container = document.querySelector('#product_scroll')
        const pathName_ = window.location.pathname
        const pathArray = pathName_.split('/products/')

        const selectedElement = container.querySelector('[js-selected-option]')

        // all products handle
        const allProducts_ = Array.from(container.querySelectorAll('[js-dropdown-menu] li'))
        
        allProducts_.find(searchSelectedProduct => {
            pathArray.map(pathArr => {
                if(searchSelectedProduct.dataset.productHandle === pathArr) {
                    selectedElement.innerHTML = searchSelectedProduct.innerHTML
                    searchSelectedProduct.classList.add('active')
                    
                }
            })
        })

    }
    getSelected()
    autoCloseCustomDrop() 
    document.addEventListener('activeSelectedProduct', getSelected)
    document.addEventListener('init:autoCloseDrop', autoCloseCustomDrop)

    function autoCloseCustomDrop() {
        document.addEventListener('click', function(e) {
            if(!e.target.closest('[js-dropdown]')) {
                const menu_ = document.querySelectorAll('[js-dropdown-menu]')
                const dropIcon = document.querySelectorAll('[js-dropdown-icon]')
                
                menu_.forEach((menuItem, index) => {
                    if(menuItem.classList.contains('open-menu')) {
                        menuItem.classList.remove('open-menu')
                        dropIcon[index].classList.remove('icon-rotate')
                    }
                })

                // if(menu_.classList.contains('open-menu')) {
                //     menu_.classList.remove('open-menu')
                //     dropIcon.classList.remove('icon-rotate')
                // }
            }
        })
    }
})